import { Form, Row, Col } from "react-bootstrap";

const CompanySocialProfileTab = () => {
  return (
    <div className="social-tab">

      <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Facebook</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Twitter</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>LinkedIn</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Skype</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Whatsapp</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Instagram</Form.Label>
            <Form.Control />
          </Form.Group>
        </Col>
      </Row>
<style>
     {
          `
          .social-tab .form-label {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.social-tab .form-control {
  height: 38px;
  border-radius: 6px;
}

/* Focus orange */
.form-control:focus,
.form-select:focus {
  border-color: #ff6b00 !important;
  box-shadow: 0 0 0 0.1rem rgba(255, 107, 0, 0.25) !important;
}

/* Dropdown selected orange */
select option:checked {
  background-color: #ff6b00;
  color: #fff;
}

/* Mobile */
@media (max-width: 768px) {
  .social-tab .row {
    flex-direction: column;
  }
}`
     }
</style>
    </div>
  );
};

export default CompanySocialProfileTab;